module.exports = __webpack_public_path__ + "media/images/client/MediaReviews/village-be6765d50d269dc74c800f140f825f04.svg";